import { Grid } from "@mui/material";
import LoadingSmallCard from "components/ui/Skeleton/LoadingSmallCard";
import { useGlobalContext } from "context/GlobalContext";
import SortContext from "context/SortContext";
import Product from "features/Category/categoryProd/components/Product";
import React, { useEffect } from "react";
import { useInView } from "react-intersection-observer";
import { transformData } from "utils/transformdata";
import { useCategories } from "../api/get-categories";
import Category from "./Category";
import DataNotFound from "components/ui/datanotfound/DataNotFound";

const Categories = () => {
  const { selectedSortValue, sortOptions, search } = React.useContext(SortContext);
  const selectedOption = sortOptions.find((option) => option.id == selectedSortValue);
  const selectedSortBY = selectedOption?.sortBy;
  const selectedSortOrder = selectedOption?.order;
  const {
    setFilterChangeCount,
    setDisplayCount,
    dynamicfilterCount,
    setFilterChangeDesignCount,
    filterChangeCount,
    filterChangeDesignCount,
    setSearchResultCount,
    setDynamicFilterCount,
    setSearchPlaceHolder,
  } = useGlobalContext();

  const { data, fetchNextPage, hasNextPage, isFetchingNextPage, isLoading, isError, error } = useCategories({
    limit: 20,
    sortBy: selectedSortBY,
    order: selectedSortOrder,
    searchTerm: search,
  });

  useEffect(() => {
    setSearchPlaceHolder("Search By Category or Design Number");
    if (search === "") {
      setDynamicFilterCount(true);
    }
    if (dynamicfilterCount) {
      setFilterChangeCount(data?.pages[0]?.totalCount);
      setFilterChangeDesignCount(data?.pages[0]?.totalDesigncount);
      setSearchResultCount(data?.pages[0]?.totalCount);
    } else {
      setSearchResultCount(data?.pages[0]?.totalCount);
      setFilterChangeCount(filterChangeCount);
      setFilterChangeDesignCount(filterChangeDesignCount);
    }
    setDisplayCount(true);
    return () => {
      setSearchResultCount(0);
      setFilterChangeCount(0);
      setFilterChangeDesignCount(0);
      setDisplayCount(false);
      setSearchPlaceHolder("");
    };
  }, [data]);

  const { ref, inView } = useInView({
    triggerOnce: false,
    threshold: 1.0,
  });

  useEffect(() => {
    if (inView && hasNextPage) {
      fetchNextPage();
    }
  }, [inView, hasNextPage, fetchNextPage]);

  if (isLoading) return <LoadingSmallCard count={20} />;
  if (isError) return <div>Error: {error.message}</div>;

  const hasNoResults =
    search &&
    data?.pages?.every(
      (page) => !page?.categories?.length && !page?.cardData?.length
    );

  if (hasNoResults) return <DataNotFound message={`No results found for "${search}"`} />;

  return (
    <>
      <Grid
        container
        className="Grid-padding"
        direction="row"
        justifyContent="flex-start"
        sx={{ flex: "1 1 1", display: "flex", alignItems: "center", justifyContent: "flex-start", gap: "30px", rowGap: "32px" }}
      >
        {data?.pages?.map((page, pageIndex) => (
          <React.Fragment key={`page-${pageIndex}`}>
            {page.categories.map((category, _ind) => (
              <Grid key={`${_ind}-${category.category}`}>
                <Category category={category} />
              </Grid>
            ))}

            {page.cardData.map((design) => {
              // console.log("design--->>",design)
              const transformedProduct = transformData(design);
              return <Product product={transformedProduct} key={design._id} />;
            })}
          </React.Fragment>
        ))}
      </Grid>
      {isFetchingNextPage && <LoadingSmallCard count={10} />}
      <div ref={ref} style={{ height: "20px", marginTop: "10px" }} />
    </>
  );
};

export default Categories;
